import styled, { css } from 'styled-components';
import Color from '../../styles/color';

export const Card = styled('div')`
  background: ${Color.white};
  border: 1px solid ${Color.neutral60};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 24px;
  max-width: 550px;
  margin: 0 auto;
`;

export const ContainerTerm = styled('div')<{ is3p: boolean }>`
  .root {
    text-rendering: geometricPrecision;
    word-wrap: break-word;
    text-align: left;
    font-size: 16px;
    line-height: 22px;
  }

  .title {
    margin: 15px 45px;
    text-align: center;
  }

  strong {
    font-size: 14px;
    color: ${Color.neutral};
    font-weight: bold;
  }

  p {
    margin-bottom: ${props => props.is3p ? '0px' : '18px'};
  }

  ${props => props.is3p && css`
    h1 {
      margin: 0px 45px;
      text-align: center;
      text-transform: uppercase;
    }
  `}
`;
export const DownloadButton = styled('button')`
  position: relative;
  display: inline-flex;
  cursor: pointer;
  background-color: #E1E1E1;
  float: right;

  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 0;
  padding: 0;

  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

export const Icon = styled('img')``;

export const ContainerError = styled('div')`
  text-align: center;
`;

export const ContainerPdf = styled('div')`
    text-rendering: geometricPrecision;
    text-align: justify;
    letter-spacing: 1px;
    line-height: 10px;

    .root {
      font-size: 8px;
      font-family: monospace;
    }

    .title {
      text-align: center;
      font-size: 10px;
      font-weight: bold;
    }

    strong {
      font-weight: bold;
    }
`;

export const ContainerTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;

  h2 {
    font-size: 24px;
  }
`;
